"use client";

import { c as _c } from "react/compiler-runtime";
import { isChannel } from "@website/utils/channel/helpers";
import { AgenciesButton } from "@website/widget/header/components/agencies/agencies-button";
import { BackButton } from "@website/widget/header/components/back/back-button";
import { Logo } from "@website/widget/header/components/logo/logo";
import { MyTrips } from "@website/widget/header/components/my-trips/my-trips";
import { SupportAgent } from "@website/widget/header/components/support-agent/support-agent";
import { TravelServicesMobileDrawer } from "@website/widget/header/components/travel-services/TravelServicesMobileDrawer";
import { TravelServicesDesktop } from "@website/widget/header/components/travel-services/travel-services-desktop";
import { HeaderLogin } from "@website/widget/header/header-login/header-login";
import { HeaderPropertiesType } from "@website/widget/header/header.types";
import { LoginModal } from "@website/widget/login";
import { Suspense } from "react";
export const Header = t0 => {
  const $ = _c(41);
  const {
    showBackButton: t1,
    isHomePage: t2,
    minimalView,
    hideBackButton,
    title,
    customTitle,
    minimalLogo
  } = t0;
  const showBackButtonParameter = t1 === undefined ? false : t1;
  const isHomePage = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = isChannel(["jek"]);
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const isJek = t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = isChannel(["jek"]);
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const isAndroidOrWebApp = t4;
  const showBackButton = !hideBackButton && (showBackButtonParameter || isJek || isAndroidOrWebApp && !isHomePage);
  const showAppModeTitle = (isJek || isAndroidOrWebApp) && Boolean(title);
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = isChannel(["b2b", "website", "telesale", "web-app", "android", "safarmarket", "jek"]);
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const showAuth = t5;
  let t6;
  if ($[3] !== minimalView) {
    t6 = !minimalView && isChannel(["website"]);
    $[3] = minimalView;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const showAgenciesButton = t6;
  let t7;
  if ($[5] !== minimalView) {
    t7 = !minimalView && isChannel(["website", "telesale", "web-app", "android", "safarmarket", "jek"]);
    $[5] = minimalView;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const showMyTrips = t7;
  let t8;
  if ($[7] !== minimalView || $[8] !== showBackButton) {
    t8 = !minimalView && !showBackButton && isChannel(["website", "telesale", "web-app", "android", "safarmarket"]);
    $[7] = minimalView;
    $[8] = showBackButton;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const showTravelServices = t8;
  let t9;
  if ($[10] !== isHomePage || $[11] !== showBackButton) {
    t9 = showBackButton && <Suspense><BackButton isHomePage={isHomePage} /></Suspense>;
    $[10] = isHomePage;
    $[11] = showBackButton;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== showTravelServices) {
    t10 = showTravelServices && <TravelServicesMobileDrawer />;
    $[13] = showTravelServices;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== customTitle || $[16] !== minimalLogo || $[17] !== showAppModeTitle || $[18] !== title) {
    t11 = showAppModeTitle ? <div className="text-headline-6 font-normal">{title}</div> : <><Logo minimalLogo={minimalLogo} />{Boolean(customTitle) && <><div className="bg-outline-thin -ms-1 me-1 h-[32px] w-px lg:-ms-2 lg:me-0 lg:h-[40px]" /><div className="text-on-surface-medium-emphasis text-sm font-bold lg:text-base">{customTitle}</div></>}</>;
    $[15] = customTitle;
    $[16] = minimalLogo;
    $[17] = showAppModeTitle;
    $[18] = title;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== showTravelServices) {
    t12 = showTravelServices && <TravelServicesDesktop />;
    $[20] = showTravelServices;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== showAgenciesButton) {
    t13 = showAgenciesButton && <AgenciesButton />;
    $[22] = showAgenciesButton;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t12 || $[27] !== t13 || $[28] !== t9) {
    t14 = <nav className="flex h-full items-center gap-2 lg:gap-4">{t9}{t10}{t11}{t12}{t13}</nav>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
    $[28] = t9;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="flex-1" />;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== showMyTrips) {
    t16 = showMyTrips && <Suspense><MyTrips /></Suspense>;
    $[31] = showMyTrips;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  let t18;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <SupportAgent />;
    t18 = showAuth && <Suspense><HeaderLogin /></Suspense>;
    $[33] = t17;
    $[34] = t18;
  } else {
    t17 = $[33];
    t18 = $[34];
  }
  let t19;
  if ($[35] !== t14 || $[36] !== t16) {
    t19 = <div className="mx-0 flex size-full items-center gap-2 lg:gap-4 xl:mx-auto xl:w-[1200px]">{t14}{t15}{t16}{t17}{t18}</div>;
    $[35] = t14;
    $[36] = t16;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Suspense><LoginModal /></Suspense>;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== t19) {
    t21 = <div className="border-b-outline-thin relative z-20 flex h-16 w-full border-b bg-white px-4 lg:z-40 lg:px-6 xl:px-10">{t19}{t20}</div>;
    $[39] = t19;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  return t21;
};